module.exports = __webpack_public_path__ + "static/media/400111_01.2adc6d7b.png";